// extracted by mini-css-extract-plugin
module.exports = {"favorite":"svings-term-list_favorite_XPlHJ","active":"svings-term-list_active_YwJ_l"};